module.exports = __webpack_public_path__ + "img/n2.378b55d5.jpg";